/**
 * Location-based GST helpers (Singapore GST orgs / e-learning programmes).
 * Answer is stored on registration.additional_data.taking_course_in_singapore ('yes' | 'no').
 * Only Non-Singapore Resident (Passport) students are asked / can be GST-exempt.
 */

export function isSingaporeCitizenOrPR(nationality) {
  if (!nationality) return false;
  const value = String(nationality).trim();
  return (
    value === 'Singapore Citizen' ||
    value === 'Singapore Permanent Resident' ||
    value === 'Singapore Citizen / PR'
  );
}

/** Passport ID type only (not Work Pass / FIN). */
export function isNonSingaporeResidentPassport(nationality) {
  if (!nationality) return false;
  const value = String(nationality).trim();
  return (
    value === 'Non-Singapore Resident (Passport No)' ||
    value === 'Non-Singapore Resident (Foreign Passport)' ||
    value === 'Non-Singapore Resident( Passport No)'
  );
}

export function getTakingCourseInSingapore(additionalData) {
  if (!additionalData || typeof additionalData !== 'object') return null;
  const value = additionalData.taking_course_in_singapore;
  if (value === 'yes' || value === 'no') return value;
  return null;
}

/**
 * Whether GST should be applied for fees / checkout display.
 * Org GST off → never. Non location-based courses → org GST.
 * Location-based + passport student + taking_course_in_singapore === 'no' → no GST.
 * Citizen/PR and Work Pass/FIN always get GST when org GST is on.
 * Unanswered passport defaults to applying GST (safer for tax).
 */
export function shouldApplyGst({
  orgGstEnabled,
  locationBasedGst,
  nationality,
  takingCourseInSingapore,
}) {
  if (!orgGstEnabled) return false;
  if (!locationBasedGst) return true;
  if (!isNonSingaporeResidentPassport(nationality)) return true;
  if (takingCourseInSingapore === 'no') return false;
  return true;
}

export function shouldAskTakingCourseInSingapore({ locationBasedGst, nationality }) {
  return !!locationBasedGst && isNonSingaporeResidentPassport(nationality);
}
